// Convierte los objetos de una lista al formato {name,value}
export const objToOptions = (listObj = [], name, value) =>
  (listObj || []).reduce(
    (listOption, obj) =>
      listOption.concat({ name: obj[name], value: obj[value] }),
    []
  );

// For http request

// URL Query to Object
export const queryToObj = (query) =>
  query
    .replace("?", "")
    .split("&")
    .reduce((response, parameter) => {
      const [name, value] = parameter.split("=");
      return { ...response, [name]: value };
    }, {});

// Object to URL Query
export const objToQuery = (obj) => {
  const params = new URLSearchParams();
  let otherstring = "";
  Object.keys(obj || {}).map(criteriaName => {
    const criteriaValue = obj[criteriaName];
    if (criteriaName == "sort" && Array.isArray(criteriaValue)) {
      otherstring += "sort=" + criteriaValue.join("&sort=")
    }
    else if (Array.isArray(criteriaValue)) {
      if (criteriaValue.filter(c => c !== undefined && criteriaValue !== null && criteriaValue !== "").length) params.set(criteriaName, decodeURIComponent(criteriaValue));
    }
    //
    else if (criteriaValue !== undefined && criteriaValue !== null && criteriaValue !== "") {
      params.set(criteriaName, decodeURIComponent(criteriaValue));
    }
  });
  let query = params.toString();
  if (otherstring && query) {
    query = query + "&" + otherstring
  }
  else if (otherstring) {
    query = otherstring;
  }
  return query ? '?' + query : '';

}


// Search Object with "Active" props to Object
export const searchPropToObj = (searchProp) => {
  const newSerch = {};
  Object.keys(searchProp)
    .filter((prop) => 1 + prop.indexOf("Active") && searchProp[prop])
    .forEach((prop) => {
      const valueProp = prop.replace("Active", "");
      if (searchProp[valueProp] !== -1)
        newSerch[valueProp] = searchProp[valueProp];
    });
  return newSerch;
};
